var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('DashboardSidebar'),_c('div',{staticClass:"main-panel"},[_c('DashboardNavbar'),_c('DashboardContent'),_c('DashboardFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }